module.exports = __webpack_public_path__ + "static/fualaunch-609160b1b5d15245ecd2bf11a82cb01d.png";